// @generated da scripts/i18n-sr-cyrl.mjs — NON EDITARE A MANO.
// i18n area 'tasks' — locale sr-Cyrl-RS: TRASLITTERAZIONE MECCANICA
// di tasks.sr-Latn-RS.ts (srpska latinica). Ogni modifica va fatta
// sulla locale sr-Latn-RS e poi rigenerata con: node scripts/i18n-sr-cyrl.mjs
// Sidecar anti-stantie: ../meta/tasks.sr-Cyrl-RS.meta.json.
import type { enUS } from './tasks'

export const srCyrlRS: typeof enUS = {
  macrotasks: {
    title: 'Макрозадаци',
    subtitle: 'Сложене операције — могу се наставити од неуспешног корака, или прекинути',
    colType: 'Тип',
    colTarget: 'Објекат',
    colPhase: 'Фаза',
    colSteps: 'Кораци',
    empty: 'Нема макрозадатака',
    detail: 'Детаљи',
    failedAt: 'неуспешан на',
    resume: 'Покушај поново од неуспешног корака',
    abort: 'Прекини све',
    cancel: 'Откажи',
    actionError: 'Акција је одбијена'
  },
  tasks: {
    title: 'Задаци',
    searchPlaceholder: 'Претражи по типу или targetu',
    type: 'Тип',
    target: 'Target',
    phaseLabel: 'Фаза',
    progress: 'Напредак',
    started: 'Започето',
    finished: 'Завршено',
    node: 'Чвор',
    empty: 'Нема задатака',
    loadError: 'Задатке није могуће учитати — да ли је TVirt backend доступан?',
    limboHint: "Чвор '{node}' недоступан од {time} — задатак држи write lease на свом targetu док се чвор не врати или не буде атестиран као угашен",
    nodeAttested: 'Чвор атестиран као угашен',
    phase: {
      queued: 'У реду чекања',
      running: 'У току',
      succeeded: 'Завршен',
      failed: 'Неуспешан',
      cancelled: 'Отказан',
      'failed-at-step': 'Неуспешан на једном кораку',
      aborted: 'Прекинут'
    },
    dropdown: {
      tooltip: 'Задаци у току',
      title: 'Задаци у току',
      empty: 'Нема задатака у току',
      viewAll: 'Види све задатке'
    },
    detail: {
      open: 'Детаљи',
      scope: 'Опсег',
      message: 'Порука',
      params: 'Параметри',
      result: 'Резултат',
      errorTitle: 'Грешка',
      steps: 'Кораци',
      failedAt: 'неуспешан на',
      superseded: 'превазиђен',

      // Dialog standard (round #156): il posto del figlio nel piano del padre,
      // il padre stesso (apribile in-place) e il passo colpevole.
      step: 'Корак',
      parent: 'Родитељски задатак',
      failedStep: 'Неуспешан корак',
      log: 'Log',
      logEmpty: 'Још нема редова у logu',
      close: 'Затвори'
    },
    actions: {
      cancel: 'Откажи',
      resume: 'Покушај поново од неуспешног корака',
      abort: 'Прекини све (undo завршених корака)',
      refused: 'Акција је одбијена'
    }
  },
  events: {
    loadError: 'Дневник није могао да се учита — да ли је TVirt backend доступан?',
    title: 'Догађаји',
    subtitle: 'Историјско памћење кластера: свршене чињенице, од најновијих',
    filterSeverity: 'Озбиљност',
    filterCategory: 'Категорија',
    filterAll: 'Све',
    searchLabel: 'Претрага',
    searchPlaceholder: 'Претражи цео дневник',
    subjectFilter: 'Догађаји за {subject} — прикажи све',
    colAt: 'Када',
    colSeverity: 'Озбиљност',
    colType: 'Тип',
    colSubject: 'Субјект',
    colActor: 'Ко',
    colNode: 'Ноде',
    colMessage: 'Порука',
    empty: 'Нема догађаја',
    loadMore: 'Учитај још',
    actorSystem: 'систем',
    detailScope: 'Scope',
    detailTask: 'Таск',
    detailId: 'ID догађаја',
    taskCollectedHint: 'Таск има краћу ретенцију: када се прикупи, link више не одговара',
    severity: {
      info: 'Информација',
      warning: 'Упозорење',
      error: 'Грешка',
      critical: 'Критично'
    },
    category: {
      lifecycle: 'Животни циклус',
      config: 'Конфигурација',
      availability: 'Доступност',
      security: 'Безбедност'
    },
    type: {
      haNetsvcFailedOver: 'Failover мрежног сервиса',
      haNetsvcNoCandidate: 'Мрежни сервис без кандидат-чвора',
      haNetsvcReaped: 'Локална инстанца пожњевена при повратку',
      netsvcFloatipMoved: 'Плутајући IP премештен на другог држаоца',
      netsvcFloatipNoHolder: 'Плутајући IP без здравог циља',
      haAppFailedOver: 'Failover App instance',
      haAppNoCandidate: 'App инстанца без кандидата чвора',
      haAppStorageLocalSkip: 'App инстанца није пребачена: трајни подаци локални на мртвом чвору',
      haAppReaped: 'Локални под App instance пожњевен при повратку'
    }
  },
  audit: {
    loadError: 'Регистар аудита није могао да се учита — да ли је TVirt backend доступан?',
    title: 'Аудит',
    subtitle: 'Ко је шта урадио, када и над којим објектом — покушане радње, укључујући одбијања',
    filterOutcome: 'Исход',
    filterAll: 'Сви',
    filterSudo: 'Само уздигнуте радње',
    colAt: 'Када',
    colActor: 'Ко',
    colAction: 'Радња',
    colTarget: 'Објекат',
    colOutcome: 'Исход',
    colNode: 'Ноде',
    empty: 'Нема забележених радњи',
    loadMore: 'Учитај још',
    sudoBadge: 'sudo',
    tokenBadge: 'app токен',
    detailScope: 'Scope',
    detailPath: 'Рута',
    detailProblem: 'Разлог',
    detailTask: 'Таск',
    detailClientIp: 'Одакле',
    detailId: 'ID записа',
    detailSession: 'Сесија',
    taskHint: 'Исход прихваћене радње живи у дневнику догађаја, под истим ид-ом таска',
    outcome: {
      succeeded: 'Успело',
      accepted: 'Прихваћено',
      denied: 'Ускраћено',
      rejected: 'Одбијено',
      failed: 'Неуспело'
    }
  },
  notifications: {
    loadError: 'Обавештења нису могла да се учитају — да ли је TVirt backend доступан?',
    actionError: 'Акција је одбијена',
    title: 'Обавештења',
    subtitle: 'Одредишта према којима чињенице дневника напуштају кластер',
    rulesTitle: 'Правила',
    rulesSubtitle: 'Које чињенице излазе и куда',
    deliveriesTitle: 'Испоруке',
    deliveriesSubtitle: 'Исход сваког обавештења, са разлогом када не успе',
    colName: 'Назив',
    colKind: 'Тип',
    colWhere: 'Куда',
    colScope: 'Scope',
    colSeverity: 'Озбиљност',
    colMatch: 'Филтер',
    colTargets: 'Одредиште',
    colAt: 'Када',
    colState: 'Стање',
    colEvent: 'Догађај',
    colAttempts: 'Покушаји',
    colOutcome: 'Исход',
    empty: 'Нема редова',
    matchAll: 'све чињенице',
    test: 'Испробај',
    testOk: 'Пробно обавештење испоручено на {target}',
    testFailed: 'Проба према {target} није успела: {reason}',
    retry: 'Врати у ред',
    retried: 'Испорука враћена у ред',
    grouped: 'и још {count} понављања',
    state: {
      failed: 'Неуспела',
      pending: 'У реду',
      sending: 'Шаље се',
      sent: 'Послата'
    },
    tabTargets: 'Одредишта',
    tabRules: 'Правила',
    tabDeliveries: 'Доставе',
    targetCreateTitle: 'Ново одредиште',
    ruleCreateTitle: 'Ново правило',
    nameHint: 'Мала слова, цифре и цртице; јединствено по опсегу',
    kindImmutableHint: 'Непроменљиво: промена типа значи креирање другог одредишта',
    kindSmtp: 'Пошта (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Стање',
    enabledOn: 'Активно',
    enabledOff: 'Заустављено',
    smtpHost: 'SMTP сервер',
    smtpPort: 'Порт',
    smtpPortHint: 'Уобичајено: 25 без TLS-а, 587 са старттлс, 465 са тлс',
    smtpSecurity: 'Безбедност',
    smtpFrom: 'Пошиљалац',
    smtpTo: 'Примаоци',
    smtpToHint: 'Једна или више адреса раздвојених запетом',
    webhookUrl: 'URL',
    payload: 'Садржај',
    payloadHint: 'Са минимал порука и подаци догађаја не излазе из кластера',
    credential: 'Акредитив',
    credentialNone: 'Нема',
    credentialHintSmtp: 'Рачун релеја из складишта кључева; нема значи анонимни SMTP',
    credentialHintWebhook: 'Тајна за потписивање из складишта кључева; без потписа свако ко зна URL може се представити као кластер',
    minSeverityHint: 'Праг, не скуп: од ове тежине и више',
    categories: 'Категорије',
    categoriesHint: 'Празно = све',
    types: 'Типови догађаја',
    typesHint: 'Раздвојени запетом; празно = сви. Непознат тип се одбија',
    targetsHint: 'Најмање једно; морају бити у опсегу правила или у његовом претку',
    recursiveOn: 'И подређени опсези',
    recursiveOff: 'Само овај опсег',
    recursiveHint: 'Ресурси живе у листовима: без деце правило на корену обавештава готово ништа',
    repeatWindow: 'Прозор груписања (с)',
    repeatWindowHint: 'Унутар прозора понављања не шаљу пошту: броје се на првом. 0 искључује',
    targetInUseError: 'Одредиште {name} још користи једно правило'
  }
}
